var nameTransformer = name =>
  name.split('[').map(el => el.replace(/\]/, ''));

const extractFormValues = ({
  formSelector = 'form',
  transformName = nameTransformer,
}) => {
  var form = document.querySelector(formSelector);
  var paramsObj = {};

  if (typeof form === 'undefined') {
    throw new Error('the formSelector option must find a form');
  }

  if (form.nodeName !== 'FORM') {
    throw new Error('the formSelector option must find an element with nodeName FORM');
  }

  var addValueToParamsObj = (name, val, id) => {
    var parts = transformName(name, id);
    var lastIndex = parts.length - 1;
    parts.reduce((accumulator, currentValue) => {
      if (currentValue === parts[lastIndex]) {
        accumulator[currentValue] = val;
      } else {
        accumulator[currentValue] = accumulator[currentValue] || {};
      }
      return accumulator[currentValue];
    }, paramsObj);
    return paramsObj;
  };

  var elements = form.querySelectorAll('input, select');

  for (let i = 0; i < elements.length; i += 1) {
    var el = elements[i];

    // Only extract value if the input is not a checkbox
    // or if it is a checkbox and it's checked
    if (el.type !== 'checkbox' || (el.type === 'checkbox' && el.checked)) {
      addValueToParamsObj(el.name, el.value, el.id);
    }
  }

  return paramsObj;
};

export default extractFormValues;
